<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.75">
    <path d="M17 7L7 17" stroke="#C0C5D2" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
    <path d="M7 7L17 17" stroke="#C0C5D2" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
  </g>
</svg>
